import React from 'react';
import { Grid, Modal, Table } from 'semantic-ui-react';
import { Helmet } from '@plone/volto/helpers/Helmet/Helmet';
import { Link } from 'react-router-dom';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import { useDispatch, useSelector } from 'react-redux';
import { searchContent } from '@plone/volto/actions/search/search';

const EnhancedCVOverlay = () => {
  const content = useSelector((store) => store?.content?.data);
  const metadata_fields = [
    'books',
    'articles',
    'refereedProceedings',
    'nonRefereedProceedings',
    'chapters',
    'monographs',
    'reviews',
  ];
  const portal_type = 'faculty2';
  const id = content?.id;
  const dispatch = useDispatch();
  const results = useSelector((state) => state.search.subrequests.content?.items)?.[0];
  const fetchContents = async () => {
    dispatch(searchContent(flattenToAppURL(`${content?.['@id']}`), {
        metadata_fields: metadata_fields,
        id: id,
        portal_type: portal_type,
      },
      'content'));
  };
  const EnhancedCVWorks = ({ title, abbreviation = '' }) => {
    return (
      <div>
        <li>
          <h3>{title}</h3>
          <ol type='A'>
            {!results?.books && null}
            <li>
              {' '}
              Books:
              <br />
              {results?.books &&
                results?.books.map((item) => (
                  <ul>
                    {item?.status === abbreviation && (
                      <li>
                        <span>{item?.authors}</span>. <u>{item?.title}</u>.
                        <span>{item?.place}</span>:{' '}
                        <span>{item?.publisher}</span>,<span>{item?.date}</span>
                        . <span>{item?.pages}</span>.
                      </li>
                    )}
                  </ul>
                ))}
            </li>
            {!results?.articles && null}
            <li>
              Papers in Professional Journals:
              <ol>
                <li>
                  {' '}
                  Articles:
                  <br />
                  {results?.articles &&
                    results?.articles.map((item) => (
                      <ul>
                        {item?.status === abbreviation && (
                          <li>
                            <span>{item?.authors}</span>. &quot;
                            <span>{item?.title}</span>
                            .&quot;
                            <u>{item?.journalTitle}</u>.{' '}
                            <span>{item?.volume}</span>
                            <span>{item?.date}</span>:{' '}
                            <span>{item?.pages}</span>.{' '}
                          </li>
                        )}
                      </ul>
                    ))}
                </li>
                {!results?.refereedProceedings && null}
                <li>
                  Proceedings:
                  <ol type='a'>
                    <li>
                      {' '}
                      Refereed Proceedings <br />
                      {results?.refereedProceedings &&
                        results?.refereedProceedings.map((item) => (
                          <ul>
                            {item?.status === abbreviation && (
                              <li>
                                <span>{item?.authors}</span>. &quot;
                                <span>{item?.title}</span>.&quot;
                                <u>{item?.journalTitle}</u>.{' '}
                                <span>{item?.volume}</span>
                                <span>{item?.date}</span>:{' '}
                                <span>{item?.pages}</span>.{' '}
                              </li>
                            )}
                          </ul>
                        ))}
                    </li>
                    {!results?.nonRefereedProceedings && null}
                    <li>
                      Non-Refereed Proceedings
                      <br />
                      {results?.nonRefereedProceedings &&
                        results?.nonRefereedProceedings.map((item) => (
                          <ul>
                            {item?.status === abbreviation && (
                              <li>
                                <span>{item?.authors}</span>. &quot;
                                <span>{item?.title}</span>.&quot;
                                <u>{item?.journalTitle}</u>.{' '}
                                <span>{item?.volume}</span>
                                <span>{item?.date}</span>:{' '}
                                <span>{item?.pages}</span>.{' '}
                              </li>
                            )}
                          </ul>
                        ))}
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
            {!results?.chapters && null}
            <li>
              Chapters in Books:
              <br />
              {results?.chapters &&
                results?.chapters.map((item) => (
                  <ul>
                    {item?.status === abbreviation && (
                      <li>
                        <span>{item?.authors}</span>. &quot;
                        <span>{item?.title}</span>.&quot;{' '}
                        <u>{item?.journalTitle}</u>.<span>{item?.volume}</span>{' '}
                        <span>{item?.date}</span>:<span>{item?.pages}</span>.{' '}
                      </li>
                    )}
                  </ul>
                ))}
            </li>
            {!results?.monographs && null}
            <li>
              Government Reports or Monographs
              <br />
              {results?.monographs &&
                results?.monographs.map((item) => (
                  <ul>
                    {item?.status === abbreviation && (
                      <li>
                        <span>{item?.authors}</span>. &quot;
                        <span>{item?.title}</span>.&quot;{' '}
                        <u>{item?.journalTitle}</u>.<span>{item?.volume}</span>{' '}
                        <span>{item?.date}</span>:<span>{item?.pages}</span>.{' '}
                      </li>
                    )}
                  </ul>
                ))}
            </li>
            {!results?.reviews && null}
            <li>
              Book Reviews: <br />
              {results?.reviews &&
                results?.reviews.map((item) => (
                  <ul>
                    {item?.status === abbreviation && (
                      <li>
                        &quot;<a href={item.url}>{item.publication}</a>
                        &quot;  <i>{item?.title}</i>, {item?.publisher}. {item.date}:{item.pages} {item?.place}.
                      </li>
                    )}
                  </ul>
                ))}
            </li>
          </ol>
        </li>
      </div>
    );
  };
  return (
    <Modal
      size='fullscreen'
      className='view-wrapper'
      trigger={
        <Link
          className='ui button primary'
          to={flattenToAppURL(`${content['@id']}/enhanced-c-v`)}
          onClick={(e) => {
            e.preventDefault();
            fetchContents();
            return false;
          }}
        >
          Enhanced Curriculum Vitae
        </Link>
      }
      closeIcon
    >
      <Modal.Header>
        <h1 className='documentFirstHeading'>
          {content.first_name} {content.last_name}
        </h1>
        <Helmet title={`${content.title} — York College / CUNY`} />
      </Modal.Header>
      <Modal.Content scrolling>
        <div>
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <p
                  dangerouslySetInnerHTML={{
                    __html: content?.briefBio,
                  }}
                />
                {content?.scholarEnhance ? (
                  <div>
                    <h2>Scholarship Enhancements</h2>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: content?.scholarEnhance,
                      }}
                    />
                  </div>
                ) : null}
                {content?.teachEnhance ? (
                  <div>
                    <h2>Teaching Enhancements</h2>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: content?.teachEnhance,
                      }}
                    />
                  </div>
                ) : null}
                {content?.pubEnhance ? (
                  <div>
                    <h2>Publications Enhancements</h2>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: content?.pubEnhance,
                      }}
                    />
                  </div>
                ) : null}
                <h2>Curriculum Vitae</h2>
                <ol>
                  <li>
                    <h3>Education</h3>
                    <Table className='table'>
                      <Table.Row>
                        <Table.HeaderCell>Degree</Table.HeaderCell>
                        <Table.HeaderCell>Institution</Table.HeaderCell>
                        <Table.HeaderCell>Field</Table.HeaderCell>
                        <Table.HeaderCell>Dates</Table.HeaderCell>
                      </Table.Row>
                      {content?.education
                        ? content?.education.map((item) => (
                          <Table.Row>
                            <Table.Cell>
                              <span>{item.degree}</span>&nbsp;
                            </Table.Cell>
                            <Table.Cell>
                              <span>{item.institution}</span>&nbsp;
                            </Table.Cell>
                            <Table.Cell>
                              <span>{item.area}</span>&nbsp;
                            </Table.Cell>
                            <Table.Cell>
                              <span>{item.year}</span>&nbsp;
                            </Table.Cell>
                          </Table.Row>
                        ))
                        : null}
                    </Table>
                    <br />
                  </li>
                  <li>
                    <h3>Full-Time Academic Experience</h3>
                    <Table className='table'>
                      <Table.Row>
                        <Table.HeaderCell scope='col'>
                          Institution
                        </Table.HeaderCell>
                        <Table.HeaderCell scope='col'>Rank</Table.HeaderCell>
                        <Table.HeaderCell scope='col'>Field</Table.HeaderCell>
                        <Table.HeaderCell scope='col'>Dates</Table.HeaderCell>
                      </Table.Row>
                      {content?.experienceFT
                        ? content?.experienceFT.map((item) => (
                          <Table.Row>
                            <Table.Cell>
                              <span>{item.institution}</span>
                              &nbsp;
                            </Table.Cell>
                            <Table.Cell>
                              <span>{item.rank}</span>&nbsp;
                            </Table.Cell>
                            <Table.Cell>
                              <span>{item.area}</span>&nbsp;
                            </Table.Cell>
                            <Table.Cell>
                              <span>{item.dates}</span>&nbsp;
                            </Table.Cell>
                          </Table.Row>
                        ))
                        : null}
                    </Table>
                    <br />
                  </li>
                  <li>
                    <h3>Part-Time Academic Experience</h3>

                    <Table className='table'>
                      <Table.Row>
                        <Table.HeaderCell scope='col'>
                          Institution
                        </Table.HeaderCell>
                        <Table.HeaderCell scope='col'>Rank</Table.HeaderCell>
                        <Table.HeaderCell scope='col'>Field</Table.HeaderCell>
                        <Table.HeaderCell scope='col'>Dates</Table.HeaderCell>
                      </Table.Row>
                      {content?.experiencePT
                        ? content?.experiencePT.map((item) => (
                          <Table.Row>
                            <Table.Cell>
                              <span>{item.institution}</span>&nbsp;
                            </Table.Cell>
                            <Table.Cell>
                              <span>{item.rank}</span>&nbsp;
                            </Table.Cell>
                            <Table.Cell>
                              <span>{item.area}</span>&nbsp;
                            </Table.Cell>
                            <Table.Cell>
                              <span>{item.dates}</span>&nbsp;
                            </Table.Cell>
                          </Table.Row>
                        ))
                        : null}
                    </Table>
                    <br />
                  </li>
                  <li>
                    <h3>Non Academic Experience</h3>
                    <Table className='table'>
                      <Table.Row>
                        <Table.HeaderCell scope='col'>
                          Place of Employment
                        </Table.HeaderCell>
                        <Table.HeaderCell scope='col'>Title</Table.HeaderCell>
                        <Table.HeaderCell scope='col'>Date</Table.HeaderCell>
                      </Table.Row>
                      {content?.experienceNA
                        ? content?.experienceNA.map((item) => (
                          <Table.Row>
                            <Table.Cell>
                              <span>{item.institution}</span>&nbsp;
                            </Table.Cell>
                            <Table.Cell>
                              <span>{item.rank}</span>&nbsp;
                            </Table.Cell>
                            <Table.Cell>
                              <span>{item.dates}</span>&nbsp;
                            </Table.Cell>
                          </Table.Row>
                        ))
                        : null}
                    </Table>
                    <br />
                  </li>
                  <li>
                    <h3>Employment Record At This Institution</h3>
                    <Table className='table'>
                      <Table.Row>
                        <Table.HeaderCell>Rank</Table.HeaderCell>
                        <Table.HeaderCell>Dates</Table.HeaderCell>
                      </Table.Row>
                      {content?.employmentRecord
                        ? content?.employmentRecord.map((item) => (
                          <Table.Row>
                            <Table.Cell>
                              <span>{item.rank}</span>&nbsp;
                            </Table.Cell>
                            <Table.Cell>
                              <span>{item.dates}</span>&nbsp;
                            </Table.Cell>
                          </Table.Row>
                        ))
                        : null}
                    </Table>
                    <br />
                  </li>
                  <EnhancedCVWorks
                    title='Publications In Field of Expertise'
                    abbreviation='ife'
                  />

                  <EnhancedCVWorks
                    title='Other Publications'
                    abbreviation='other'
                  />
                  <li>
                    <h3>
                      Presented Papers, Lectures, And Exhibitions And
                      Performances
                    </h3>
                    <br />
                    {content?.presented
                      ? content?.presented.map((item) => (
                        <ul>
                          <li>
                            &quot;<span>{item.title}</span>&quot;{' '}
                            <span>{item.date}</span>:
                            <span>{item.audience}</span>.{' '}
                          </li>
                        </ul>
                      ))
                      : null}
                  </li>
                  <li>
                    <h3>Patents</h3>
                    <br />
                    {content?.patents
                      ? content?.patents.map((item) => (
                        <ul>
                          <li>
                            <span>{item.inventor}</span>.{' '}
                            <span>{item.date}</span>.
                            <a href={item?.url} target='_blank'>{item?.title}</a>.
                            <span>{item.country}</span> Patent
                            <span>{item.patent}</span>
                            <span>, {item.filed} </span>
                            <span>, and {item.issue} </span>.
                          </li>
                        </ul>
                      ))
                      : null}
                  </li>
                  <EnhancedCVWorks title='Submitted for Publication' abbreviation='submitted' />
                  <EnhancedCVWorks
                    title='Work In Progress'
                    abbreviation='wip'
                  />
                  <EnhancedCVWorks
                    title='Research In Progress'
                    abbreviation='rip'
                  />
                  <li>
                    <h3>Professional Honors, Prizes, Fellowships</h3>
                    {content?.professional
                      ? content?.professional.map((item) => (
                        <ul>
                          <li>
                            <span>{item.description}</span>:{' '}
                            <span>{item.dates}</span>.
                          </li>
                        </ul>
                      ))
                      : null}
                  </li>
                  <li>
                    <h3>Grants-In-Aid</h3>
                    {content?.grants
                      ? content?.grants.map((item) => (
                        <ul>
                          <li>
                            <span>{item.agency}</span>,{' '}
                            <span>{item.title}</span>.
                            <span>{item.dates}</span>:{' '}
                            <span>{item.amount}</span>.{' '}
                          </li>
                        </ul>
                      ))
                      : null}
                  </li>
                  <li>
                    <h3>Institutional Service</h3>
                    <ol type='A'>
                      <li>
                        Service to the Department
                        <br />
                        {content?.serviceDepartment
                          ? content?.serviceDepartment.map((item) => (
                            <ul>
                              <li>
                                <span>{item.description}</span>:{' '}
                                <span>{item.dates}</span>.
                              </li>
                            </ul>
                          ))
                          : null}
                      </li>
                      <li>
                        Service to the School
                        <br />
                        {content?.serviceSchool
                          ? content?.serviceSchool.map((item) => (
                            <ul>
                              <li>
                                <span>{item.description}</span>:{' '}
                                <span>{item.dates}</span>.
                              </li>
                            </ul>
                          ))
                          : null}
                      </li>
                      <li>
                        Service to the College
                        <br />
                        {content?.serviceCollege
                          ? content?.serviceCollege.map((item) => (
                            <ul>
                              <li>
                                <span>{item.description}</span>:{' '}
                                <span>{item.dates}</span>.
                              </li>
                            </ul>
                          ))
                          : null}
                      </li>
                      <li>
                        Service to the Graduate Center
                        <br />
                        {content?.serviceGraduateCenter
                          ? content?.serviceGraduateCenter.map((item) => (
                            <ul>
                              <li>
                                <span>{item.description}</span>:{' '}
                                <span>{item.dates}</span>.
                              </li>
                            </ul>
                          ))
                          : null}
                      </li>
                      <li>
                        Service to the University
                        <br />
                        {content?.serviceUniversity
                          ? content?.serviceUniversity.map((item) => (
                            <ul>
                              <li>
                                <span>{item.description}</span>:{' '}
                                <span>{item.dates}</span>.
                              </li>
                            </ul>
                          ))
                          : null}
                      </li>
                    </ol>
                  </li>
                  <li>
                    <h3>Offices Held In Professional Societies</h3>
                    {content?.officeHeld
                      ? content?.officeHeld.map((item) => (
                        <ul>
                          <li>
                            <span>{item.description}</span>:
                            <span>{item.dates}</span>.{' '}
                          </li>
                        </ul>
                      ))
                      : null}
                  </li>
                  <li>
                    <h3>Other Professional Activities And Public Service</h3>
                    {content?.activities
                      ? content?.activities.map((item) => (
                        <ul>
                          <li>
                            <span>{item.description}</span>:
                            <span>{item.dates}</span>.{' '}
                          </li>
                        </ul>
                      ))
                      : null}
                  </li>
                  <li>
                    <h3>Teaching Activities At This Institution</h3>
                    <ol type='A'>
                      <li>
                        Courses Taught (List)
                        <br />
                        <Table className='table'>
                          <Table.Row>
                            <Table.HeaderCell scope='col'>
                              Course
                            </Table.HeaderCell>
                            <Table.HeaderCell scope='col'>
                              Description
                            </Table.HeaderCell>
                          </Table.Row>
                          {content?.coursesTaught
                            ? content?.coursesTaught.map((item) => (
                              <Table.Row>
                                <Table.Cell>
                                  <span>{item.dept}</span>&nbsp;
                                  <span>{item.number}</span>&nbsp;
                                </Table.Cell>
                                <Table.Cell>
                                  <span>{item.description}</span>
                                  &nbsp;
                                </Table.Cell>
                              </Table.Row>
                            ))
                            : null}
                        </Table>
                      </li>
                      <li>
                        New courses/programs developed (list):
                        <br />
                        {content?.developed
                          ? content?.developed.map((item) => (
                            <ul>
                              <li>
                                <span>{item.title}</span>,{' '}
                                <span>{item.description}</span>.
                              </li>
                            </ul>
                          ))
                          : null}
                      </li>
                    </ol>
                  </li>
                </ol>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </Modal.Content>
    </Modal>
  );
};

export default EnhancedCVOverlay;
